var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTyping(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 16.3663L6.35323 4.80664C6.55077 4.21403 7.10535 3.81432 7.73 3.81432C8.35466 3.81432 8.90924 4.21403 9.10678 4.80664L12.96 16.3663M3.89467 12.1823H11.5653",
    stroke: "white",
    strokeOpacity: 0.95,
    strokeWidth: 2.16854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6215 1.3546C17.1273 1.21167 16.2863 1.21873 14.7922 1.3546H18.6215Z",
    fill: "white",
    fillOpacity: 0.95
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6215 1.3546C17.1273 1.21167 16.2863 1.21873 14.7922 1.3546",
    stroke: "white",
    strokeOpacity: 0.95,
    strokeWidth: 2.16854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6215 18.5863C17.0901 18.8107 16.2501 18.7984 14.7922 18.5863",
    stroke: "white",
    strokeOpacity: 0.95,
    strokeWidth: 2.16854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7068 1.3546C16.9892 8.14164 17.0176 11.9319 16.7068 18.5864",
    stroke: "white",
    strokeOpacity: 0.95,
    strokeWidth: 2.16854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTyping);
export default __webpack_public_path__ + "static/media/typing.17a4e1819df6cdcd4100cf282674787e.svg";
export { ForwardRef as ReactComponent };